// ----------------------------------------------------------------------

// SI CETTE TRADUCTION EST INCORRECTE, VEUILLEZ L'IGNORER CAR CETTE TRADUCTION EST UNIQUEMENT À DES FINS DE DÉMO
// Nous sommes heureux si vous pouvez aider à améliorer la traduction en envoyant un e-mail à support@minimals.cc.

// ----------------------------------------------------------------------

const fr = {
  demo: {
    title: 'Français',
    introduction:
      "Lorem Ipsum est simplement un faux texte de l'industrie de l'impression et de la composition. Le Lorem Ipsum est le texte factice standard de l'industrie depuis les années 1500, lorsqu'un imprimeur inconnu a pris une galère de caractères et l'a brouillé pour en faire un livre de spécimens de caractères. Il a survécu non seulement à cinq siècles, mais aussi au saut dans la composition électronique, restant essentiellement inchangé. Il a été popularisé dans les années 1960 avec la sortie de feuilles Letraset contenant des passages de Lorem Ipsum, et plus récemment avec des logiciels de publication assistée par ordinateur comme Aldus PageMaker comprenant des versions de Lorem Ipsum.",
  },
  docs: {
    hi: 'Salut',
    description: "Besoin d'aide? \n Veuillez consulter nos documents.",
    documentation: 'documentation',
  },
  dont_have_an_account: "Vous n'avez pas de compte ?",
  hi_welcome_back: 'Salut, bienvenue à nouveau',
  sign_in_to: 'Connectez-vous à',
  enter_your_details_below: 'Entrez vos coordonnées ci-dessous.',
  get_started: 'Commencer',
  email_address: 'Adresse e-mail',
  address: 'Adresse',
  city: 'Ville',
  state: 'État',
  next: 'suivant',
  password: 'le mot de passe',
  quick_links: 'Liens rapides',
  zip: 'code postal',
  forgot_password: 'mot de passe oublié?',
  country: 'Pays',
  select_country: 'Choisissez le pays',
  login: 'Connexion',
  email_must_be_a_valid_email_address: 'Email invalide',
  email_is_required: "L'e-mail est requis",
  city_is_required: 'La ville est obligatoire',
  state_is_required: "L'état est obligatoire",
  zip_is_required: 'Le code postal est requis',
  password_is_required: 'Mot de passe requis',
  already_have_an_account: 'Vous avez déjà un compte?',
  register_with_form_pay_heading:
    'Inscrivez-vous à FormPay pour obtenir des paiements en douceur de votre client.',
  get_started_absolutely_free: 'Commencez tout à fait gratuitement.',
  seven_days_trail_no_credit_card:
    "7 jours d'essai gratuit. Pas de carte de crédit nécessaire,",
  by_registering_i_agree_to_formpay: "En m'inscrivant, j'accepte FormPay",
  terms_of_service: "Conditions d'utilisation",
  and: 'et',
  privacy_policy: 'Politique de confidentialité',
  set_login_password:
    'Veuillez définir votre mot de passe pour vous connecter,',
  click: 'Cliquez ici',
  to_send_mail: 'pour envoyer du courrier.',
  passwords_must_match: 'Les mots de passe doivent correspondre',
  resend_verification: 'Renvoyer vérification',
  login_here: 'Connectez-vous ici',
  draggable: 'Les produits sont déplaçables.',
  new_password: 'nouveau mot de passe',
  confirm_password: 'Confirmez le mot de passe',
  save_password: 'Sauvegarder le mot de passe',
  invalid_token_verification: 'Vérification de jeton invalide',
  confirm_new_password: 'Confirmer passe',
  forgot_your_password: 'Mot de passe oublié?',
  update_form: 'Formulaire de mise à jour',
  publish_form: 'Publier le formulaire',
  please_enter_email_to_get_link:
    "Veuillez saisir l'adresse e-mail associée à votre compte. Nous vous enverrons un lien par e-mail pour réinitialiser votre mot de passe.",
  back_to_login: 'Retour connexion',
  page_will_open_in: "la page s'ouvrira dans",
  password_change_successfully: 'Le mot de passe a été changé avec succès',
  back_to_register: "Retour à l'inscription",
  request_sent_sucessfully: 'Demande envoyée avec succès',
  sent_confirmation_to: 'Nous avons envoyé un e-mail de confirmation à',
  please_check_your_email: 'Merci de consulter vos emails.',
  back: 'Arrière',
  email_verified_successfully: 'Courriel vérifié avec succès',
  go_to_login: 'Aller à Connexion',
  email_format_incorrect: "Le format de l'e-mail est incorrect",
  emailed_a_link_to_verify:
    'Nous avons envoyé un lien pour vérifier votre adresse e-mail',
  dont_have_email: "Vous n'avez pas de mail ?",
  resend_email: "Ré-envoyer l'email",
  email_not_verified_try_again: 'E-mail non vérifié Réessayez',
  recheck_your_email_or_register_again:
    'Il y a quelque chose qui ne va pas, veuillez re-cliquer sur votre lien e-mail ou vous inscrire à nouveau à partir de la connexion.',
  code_is_required: 'Le code est requis',
  code: 'code',
  comments: 'commentaires',
  verify: 'Vérifier',
  verification_link_resent:
    'Lien de vérification renvoyé, veuillez vérifier la boîte aux lettres.',
  sure_disc_xero: 'Voulez-vous vraiment vous déconnecter?',
  cancel: 'Annuler',
  acc_disconnected: 'Compte déconnecté',
  resend: 'Renvoyer',
  register: "S'inscrire",
  id: 'identifiant:',
  need_help: "Besoin d'aide",
  logout: 'Se déconnecter',
  connect_portals: 'Connecter les portails',
  payment_type: 'Type de paiement',
  choose_listed_portals:
    "Choisissez parmi l'un des portails HubSpot répertoriés. Si votre portail n'est pas répertorié, pour créer un nouveau portail, accédez à HubSpot",
  add_new_portal: 'Ajouter un nouveau portail',
  no_portal_found: 'Aucun portail trouvé',
  create_a_form_and_select:
    'Laissez-nous créer un formulaire pour vous ou sélectionnez un formulaire dans la liste ci-dessous',
  create_a_form: 'Créer un formulaire pour moi',
  no_portal_added_yet_click_add_new_portal_btn:
    "Aucun portail n'a encore été ajouté. Vous pouvez ajouter de nouveaux portails en cliquant sur le bouton Ajouter un nouveau portail",
  portal_listing: 'Liste de portail',
  support: 'Soutien',
  connect_Xero: 'Connectez-vous à Xéro',
  connect_Xero_single_click: 'Connectez-vous à Xero en un seul clic',
  integrations: 'Intégrations',
  hubspot_portals: 'Portails Hubspot',
  mailed_six_digit_code:
    'Nous avons envoyé un code de confirmation à 6 chiffres à acb@domain, veuillez saisir le code dans la case ci-dessous pour vérifier votre adresse e-mail.',
  resend_code: 'Renvoyer le code',
  disconnect_xero_confirmation_notice: `L'action entreprise déconnectera votre compte Xero et vous ne pourrez plus y accéder tant que vous ne l'aurez pas connecté.`,
  active: 'Activé',
  inActive: 'Inactivé',
  dashboard: 'Tableau de bord',
  tutorial: 'Didacticiel',
  schedule_meeting:
    'Planifiez une réunion individuelle avec notre expert en implémentation pour vous aider à intégrer Formpay',
  schedule_now: 'Programmez maintenant',
  active_gateways: 'Passerelles actives',
  welcome: 'Bienvenu',
  disconnect_xero: 'Déconnecter Xéro',
  connected_to_xero: 'Vous êtes connecté à Xero',
  disconnect: 'Déconnecter',
  name: 'Nom',
  created: 'Créé à',
  type: 'Taper',
  action: 'Action',
  form_listing: 'Liste des formulaires',
  forms: 'Formes',
  form: 'Formulaire',
  stripe_and_paypal_to_be_comming_soon:
    'Stripe en Paypal zijn de volgende gateways die binnenkort worden geïntegreerd',
  form_list: 'Liste des formulaires',
  create_new_form: 'Créer un nouveau formulaire',
  create_form: 'créer un formulaire',
  name_is_required: 'Le nom est requis',
  country_is_required: 'Le pays est requis',
  account_single: 'Compte',
  didnt_gateway: "Vous n'avez pas trouvé votre passerelle ?",
  portal_already_in_use: 'Le portail est déjà utilisé',
  single_document: 'Documentation',
  connect_with_us: "Encore besoin d'aide ? Connecte-toi avec nous",
  contact_now: 'Contacter maintenant',
  new_coming_soon: 'De nouvelles passerelles arrivent bientôt',
  amount_does_not_match_with_plan:
    'Le montant ne correspond pas au plan sélectionné.',
  phone_number_not_valid: 'Numéro de téléphone non valide',
  hubspot_form_is_required: 'Le formulaire HubSpot est requis',
  mode_is_required: 'Le mode est requis',
  fill_valid_amount: 'Remplissez le montant valide',
  select_currency: 'Sélectionnez la devise',
  payment_type_is_required: 'Le type de paiement est requis',
  form_not_showing: 'vous ne voyez pas votre formulaire ?',
  form_type: 'Type de formulaire',
  email_captcha_mandatory:
    'Le champ e-mail est obligatoire et le captcha doit être désactivé dans le formulaire Hubspot pour apparaître dans la liste.',
  select_atleast_one_gateway: 'Sélectionnez au moins 1 passerelle',
  edit: 'Modifier',
  your_dashboard: 'Votre tableau de bord',
  overview: 'Aperçu',
  total_order: 'Commande totale',
  form_settings: 'Paramètres du formulaire',
  no_forms_available: 'Aucun formulaire disponible',
  payment_settings: 'Paramètres du formulaire',
  payment_method: 'Mode de paiement',
  custom_amount_disabled: 'Le montant personnalisé est désactivé, supprimez le',
  enable: 'autoriser.',
  delete_form: 'Supprimer le formulaire',
  no_records_found: 'Aucun enregistrement trouvé',
  publish_the_form_to_load_preview:
    "Veuillez publier le formulaire pour charger l'aperçu",
  please_fix_errors: 'Veuillez corriger les erreurs.',
  user_onboarded:
    'Utilisateur déjà intégré, veuillez vous connecter pour continuer.',
  core_product_sold: 'Produit de base vendu',
  reference_id: 'ID de référence',
  reference_id_copy: 'ID de référence (Cliquez pour copier)',
  upsell_sold: 'Vente incitative Vendue',
  revenue_monthly: 'Transactions et revenus mensuels',
  recent_transactions: 'transactions récentes',
  monthly_yearly_users: 'Utilisateur actif mensuel + annuel',
  invoice_id: 'Identifiant de facture',
  category: 'Catégorie',
  price: 'Prix',
  form_name: 'Nom de forme',
  select_hubspot_form: 'Sélectionnez le formulaire Hubspot',
  enter_amount: 'Entrer le montant',
  single: 'Seul',
  new_invoice: 'Nouvelle facture',
  total_revenue: 'Revenu total',
  last_week: 'que la semaine dernière',
  average_order_value: 'Valeur moyenne des commandes',
  total_payment_forms: 'Total des formulaires de paiement',
  enable_test_mode: 'Activer le mode test',
  no_gateway_found: 'Aucune passerelle trouvée',
  currency: 'Monnaie',
  form_submission: 'Soumission du formulaire',
  form_submission_listing: 'Liste de soumission de formulaire',
  view_in_hubspot: 'Afficher dans HubSpot',
  status: 'Statut',
  view_all: 'Voir tout',
  none: 'Aucun',
  today: "Aujourd'hui",
  this_week: 'Cette semaine',
  this_month: 'Ce mois-ci',
  this_year: 'Cette année',
  year: 'Année',
  transactions_and_revenue: 'Transactions et revenus',
  filter: 'Filtre',
  average_revenue: 'Revenu moyen',
  total_form_submissions: 'Nombre total de soumissions de formulaires',
  already_connected_to_rzp: 'Vous êtes connecté à votre compte Razorpay',
  connected_to_rzp_test: 'Vous êtes connecté au compte de test Razorpay',
  connect_with_rzp_oauth: 'Connectez-vous à Razorpay avec OAuth',
  fill_connect_to_rzp: 'Remplissez les détails et connectez-vous à Razorpay',
  fill_all_details_to_connect_rzp:
    'Remplissez tous les détails ci-dessous pour vous connecter à Razorpay et effectuer des paiements réussis',
  total_revenue_all: 'Revenu total (tous les temps)',
  date: 'Date',
  amount: 'montant',
  connect: 'Se connecter à:',
  rzp_test: 'Connectez-vous au mode test de Razorpay',
  rzp_live: 'Connectez-vous au mode direct Razorpay',
  account_connected: 'Compte connecté avec succès',
  error_occurred: `une erreur s'est produite`,
  transaction: 'Transaction',
  transaction_listing: 'Liste des transactions',
  transactions: 'Transactions',
  revenue: 'Revenu',
  products_purchased: 'Produits achetés',
  filter_by_date: 'Filtrer par plage de dates',
  editp: 'Modifier le produit',
  success: 'Succès',
  failed: 'Failed',
  payment_gateway: 'Passerelle de paiement',
  gateways: 'Passerelles',
  manage: 'Faire en sorte',
  setup: 'Installer',
  gatway_listing: 'Liste des passerelles',
  setup_instructions: 'Instructions de configuration',
  test_merchant_id_is_required: "L'identifiant du marchand de test est requis",
  test_store_id_is_required: "L'identifiant du magasin de test est requis",
  test_public_key_is_required: "L'ID de la clé publique de test est requis",
  test_private_key_file_is_required:
    'Le fichier de clé privée de test est requis',
  live_merchant_id_is_required:
    "L'identifiant du marchand en direct est requis",
  live_store_id_is_required: "L'identifiant du magasin en direct est requis",
  live_public_key_id_is_required:
    "L'identifiant de la clé publique en direct est requis",
  live_private_key_file_is_required:
    'Le fichier de clé privée en direct est requis',
  payment_region_is_required: 'La région de paiement est requise',
  payment_currency_is_required: 'La devise de paiement est requise',
  button_language_is_required: 'La langue du bouton est requise',
  button_color_is_required: 'La couleur du bouton est requise',
  product_type_is_required: 'Le type de produit est requis',
  products: 'Des produits',
  product_settings: 'Paramètres du produit',
  add_product: 'Ajouter un nouveau produit',
  delete_product: 'Supprimer le produit',
  createp: 'Créer',
  test_account_details: 'Détails du compte test',
  merchant_id: 'Identifiant du marchand',
  store_id: 'Identifiant du magasin',
  public_key_id: 'Identifiant de clé publique',
  test_private_key_file: 'Tester le fichier de clé privée',
  live_account_details: 'Détails du compte en direct',
  live_private_key_file: 'Fichier de clé privée en direct',
  other_account_details: 'Autres détails du compte',
  No_appropriate_forms_found_in_portal:
    'Aucun formulaire approprié trouvé dans le portail',
  payment_region: 'Région de paiement',
  payment_currency: 'Monnaie de paiement',
  button_language: 'Langue des boutons',
  button_color: 'Couleur du bouton',
  product_type: 'type de produit',
  activate_gateway: 'Activer la passerelle',
  test_api_key_is_required: 'La clé API de test est requise',
  test_merchant_account_is_required: 'Un compte marchand test est requis',
  test_client_key_is_required: 'La clé client de test est requise',
  live_api_key_is_required: 'La clé API en direct est requise',
  live_merchant_account_name_is_required:
    'Le nom du compte marchand en direct est requis',
  live_client_key_is_required: 'La clé client en direct est requise',
  live_end_point_prefix_is_required:
    'Le préfixe de point de terminaison en direct est requis',
  test_api_key: 'Tester la clé API',
  test_merchant_account_name: 'Tester le nom du compte marchand',
  test_client_key: 'Tester la clé client',
  live_api_key: 'Clé API en direct',
  live_merchant_account_name: 'Nom du compte marchand en direct',
  live_client_key: 'Clé client en direct',
  live_endpoint_prefix: 'Préfixe de point de terminaison en direct',
  issue_payment_failed: 'Il y avait un problème ! Paiement échoué.',
  payment_successful_redirect_to_dashboard:
    'Paiement réussi. Redirection vers la facturation des comptes...',
  payment: 'Paiement',
  billing_details: 'Détails de la facturation',
  full_name: 'Nom complet',
  test_key_id_required: "L'identifiant de la clé de test est requis",
  test_key_secret_required: 'La clé secrète de test est requise',
  live_key_secret_required: 'Le secret de la clé en direct est requis',
  live_key_id_required: "L'identifiant de la clé en direct est requis",
  test_key_id: "Tester l'identifiant de la clé",
  live_key_id: 'Identifiant de clé en direct',
  live_key_secret: 'Clé secrète en direct',
  test_key_secret: 'Tester la clé secrète',
  description_is_required: `La description est obligatoire`,
  image_url_required: "L'URL de l'image est requise",
  image_valid_url: "Saisissez une URL d'image valide",
  image_url: "URL de l'image",
  fill_either_live_or_test_or_both:
    "Remplissez en direct et testez les deux ou l'un d'eux pour activer la passerelle",
  other_details: 'Autres détails',
  phone: 'Téléphoner',
  payment_info: 'Information de paiement',
  plan: 'Plan',
  month: 'Mois',
  saving_per_month: 'Économisez 24 $ par mois',
  order_summary: 'Récapitulatif de la commande',
  sub_total: 'Sous-total',
  total: 'Totale',
  complete_payment: 'Paiement complet',
  plan_subscribed: 'Forfait souscrit',
  you_have_been_subscribed_to: 'Vous avez été abonné à',
  your_subscription_will_end_on: 'votre abonnement prendra fin le',
  your_next_payment_date_is: "Votre prochaine date d'échéance de paiement est",
  cancel_subscription: "Annuler l'abonnement",
  something_went_wrong_contact_admin:
    "Une erreur s'est produite.Veuillez contacter l'administrateur",
  delete: 'Supprimer',
  change_password: 'Changer le mot de passe',
  your_new_password_different_from_prev_password:
    'Votre nouveau mot de passe doit être différent des mots de passe utilisés précédemment. Doit contenir au moins 8 caractères.',
  back_to_dashboard: 'Retour au tableau de bord',
  manage_hubspot_form: 'Gérer le formulaire Hubspot',
  sorry_page_not_found: 'Désolé, page introuvable !',
  sorry_could_not_find_page:
    "Désolé, nous n'avons pas trouvé la page que vous recherchez. Peut-être avez-vous mal saisi l'URL ? Assurez-vous de vérifier votre orthographe.",
  go_to_home: 'Aller à la maison',
  first_name: 'Prénom',
  last_name: 'Nom de famille',
  phone_number: 'Nom de famille',
  state_region: 'État/Région',
  save_details: 'Enregistrer les détails',
  your_form_is_published: 'Votre formulaire est publié',
  form_preview: 'Aperçu du formulaire',
  embed_code: 'Code intégré',
  add_your_hubspot_portal: 'Voeg je HubSpot Portal(s) toe aan de app',
  select_the_portal_you_want_to_connect:
    'Selecteer de portal die u wilt koppelen',
  setup_payment_gateways: 'Betalingsgateways instellen',
  create_configure_forms: 'Formulier(en) aanmaken, configureren en publiceren',
  comming_soon: 'À venir',
  page_not_found: '404 Page non trouvée',
  billing: 'facturation',
  user_accounts: 'Comptes utilisateur',
  ecommerce: 'commerce électronique',
  product_list: 'Liste de produits',
  reset_password: 'réinitialiser le mot de passe',
  send_mail: 'Envoyer un e-mail',
  connect_with_hubspot:
    'Connectez votre compte HubSpot afin que nous puissions nous connecter à votre portail',
  connect_my_hubspot_account: 'Connecter mon compte Hubspot',
  skip_this_step: 'Passer cette étape',
  connect_with_hubspot_account: 'Connectez votre compte Hubspot',
  fill_the_required_fields: 'Remplissez les champs obligatoires',
  old_password_is_required: "L'ancien mot de passe est requis",
  password_must_be_eight_char: "Mot de passe doit être d'au moins 8 caractères",
  new_password_is_required: 'Un nouveau mot de passe est requis',
  save: 'Sauver',
  old_password: 'ancien mot de passe',
  first_name_is_required: 'Le prénom est requis',
  last_name_is_required: 'Le nom de famille est requis',
  phone_must_contain_10_digit:
    'Le numéro de téléphone doit contenir 10 chiffres',
  address_is_required: "L'adresse est obligatoire",
  zipcode_is_required: 'Le code postal est requis',
  no: 'Non',
  has_been_found_yet: 'a encore été trouvé',
  will_expire_today: "expirera aujourd'hui",
  will_expire_on: 'expirera le',
  your_plan: 'Votre plan',
  test_client_id: "Tester l'identifiant du client",
  live_client_id: 'ID client en direct',
  button_layout: 'Disposition des boutons',
  button_shape: 'Forme du bouton',
  button_label: 'Libellé du bouton',
  live_client_id_is_required: "L'identifiant du client en direct est requis.",
  test_client_id_is_required: "L'identifiant du client test est requis.",
  button_layout_is_required: 'La disposition des boutons est requise.',
  button_shape_is_required: 'La forme du bouton est requise.',
  button_label_is_required: 'Le libellé du bouton est requis.',
  test_publishable_key_is_required: 'La clé publiable de test est requise',
  test_publishable_key: 'Tester la clé publiable',
  test_secret_key_is_required: 'La clé secrète de test est requise',
  test_secret_key: 'Tester la clé secrète',
  live_publishable_key_is_required: 'La clé publiable en direct est requise',
  live_publishable_key: 'Clé publiable en direct',
  live_secret_key_is_required: 'La clé secrète en direct est requise',
  live_secret_key: 'Clé secrète en direct',
  feel_free_to_contact_us_anytime:
    "N'hésitez pas à nous contacter à tout moment",
  general: 'général',
  your_trial: 'Votre parcours',
  allow_custom_amount: 'Autoriser le montant personnalisé',
  donation_form_settings: 'Paramètres du formulaire de don',
  donation_form: 'Formulaire de don',
  enter_title: 'Enter Titre',
  enter_description: 'Entrez la description',
  title: 'Titre',
  logo: 'Logo',
  suggested_amount: 'Montant suggéré',
  transaction_cost_settings: 'Paramètres de coût de transaction',
  add_transaction_cost: 'Ajouter un coût de transaction',
  transaction_cost_type: 'Type de coût de transaction',
  base_amount: 'Montant de base ',
  unit_amount: "Montant de l'unité",
  fixed: 'Fixé',
  variable: 'Variable',
  should_be_greater_than: 'Doit être supérieur à',
  is_required: 'est requis',
  redirection_setting: 'Paramètres de redirection',
  redirect_url: 'URL de redirection',
  allow_redirection: 'Autoriser la redirection',
  transaction_amount: 'Montant de la transaction',
  app: 'app',
  user: 'utilisateur',
  list: 'liste',
  shop: 'magasin',
  blog: 'blog',
  post: 'Publier',
  mail: 'poster',
  chat: 'discuter',
  cards: 'Cartes',
  posts: 'Des postes',
  create: 'Créer',
  kanban: 'kanban',
  banking: 'bancaire',
  booking: 'réservation',
  profile: 'profile',
  account: 'profil',
  product: 'produit',
  invoice: 'facturer',
  details: 'des détails',
  checkout: 'vérifier',
  calendar: 'calendrier',
  analytics: 'analytique',
  management: 'le management',
  menu_level_1: 'menu niveau 1',
  menu_level_2: 'menu niveau 2',
  menu_level_3: 'menu niveau 3',
  item_disabled: 'élément désactivé',
  item_label: "étiquette de l'article",
  item_caption: "légende de l'article",
  description: 'la description',
  other_cases: 'autres cas',
  item_by_roles: 'élément par rôles',
  only_admin_can_see_this_item: "Seul l'administrateur peut voir cet élément",
  you_have_only: "Vous n'avez que",
  quotes: 'Devis',
  left_in_trial: "jours restants de votre période d'essai",
  update: 'mettre à jour',
  one_currency_gateway:
    'Vous pouvez sélectionner des passerelles de paiement avec un type de devise',
  theme: 'Thème',
  transaction_cost_label: 'Étiquette de coût de transaction',
  thank_you_page_settings: 'Réglage de la page de remerciement',
  thank_you_title: 'Titre',
  thank_you_subtitle: 'Les sous-titres',
  thank_you_description: 'La description',
  show_donation_memory: 'Afficher/Masquer en mémoire de',
  donation_memory_label: 'Étiquette de mémoire de don',
  custom_amount: 'Montant personnalisé',
  donate_button_text: 'Faire un don Texte du bouton',
  donate_button_color: 'Faire un don Couleur du bouton',
  back_button_text: 'Texte du bouton de retour',
  back_button_color: 'Couleur du bouton Retour',
  theme_color: 'Couleur du thème',
  theme_settings: 'Paramètres du thème',
  theme_color_is_required: 'La couleur du thème est requise',
  back_button_link: 'Lien du bouton Retour',
  for_every: 'pour chaque',
  will_be_charged: 'seront facturés',
  charge: 'charge',
  per: 'par',
  upload: 'télécharger',
  bucks: 'chevreuils',
  thank_you_image: 'image de remerciement',
  share_url: 'URL de partage',
  redirectUrl: 'URL de redirection',
  enter_valid: 'Entrez valide',
  should_contain_http: '(Doit contenir http/https)',
  show_hide_in_memory_of: 'Afficher/Masquer en mémoire de',
  create_new_quote: 'Créer un nouveau devis',
  update_quote: 'Mettre à jour le devis',
  create_quote: 'créer un devis',
  your_quote_is_published: 'Votre devis est publié',
  prefer_multiple_3: 'Préférez 3 ou 6 pour correspondre au design',
  for: 'pour',
  test_mode: "mode d'essai",
  live_mode: 'vivre moe',
  in: 'dans',
  transaction_unit_amount: "montant de l'unité de transaction",
  transaction_cost_variable_base_amount:
    'Montant de base variable des coûts de transaction',
  enter_amount_press_enter: 'Entrez le montant et appuyez sur Entrée',
  need_help_success: "Besoin d'aide ? Continuez avec notre",
  success_manager: 'Gestionnaire de réussite',
  how_would_you_continue: 'Comment souhaitez-vous continuer ?',
  go_setup_instructions:
    "Continuez vous-même avec les instructions d'installation",
  privacy_notice:
    "Nous nous engageons à respecter votre vie privée. FormPay utilise les informations que vous nous fournissez pour vous contacter au sujet de nos contenus, produits et services pertinents. Vous pouvez vous désabonner de ces communications à tout moment. Pour plus d'informations, consultez notre politique de confidentialité",
  rows_per_page: 'Lignes par page',
  create_product: 'Créer un produit',
  create_coupon: 'Créer un coupon',
  hs_product_id: 'Identifiant du produit Hubspot',
  of: 'de',
  edit_product: 'Modifiez votre produit ici',
  upload_image: 'Télécharger une image',
  submit: 'Nous faire parvenir',
  create_your_product: 'Créez votre produit ici',
  no_product_found: 'Aucun produit trouvé !',
  no_coupon_found: 'Aucun coupon trouvé !',
  subscription: 'Abonnement',
  subscription_listing: 'Liste des abonnements',
  user_mail: 'Email client',
  billing_cycle: 'Cycle de facturation',
  mode: 'Mode',
  info: 'Info',
  subscription_details: `Détails de l'abonnement`,
  subs_id: `ID d'abonnement`,
  search_transactions: 'Rechercher des transactions',
  surety_notice: 'Êtes-vous sûr des mesures prises ?',
  allow_recurring: 'Autoriser la répétition',
  disable_recurring_notice:
    'La désactivation de ce paramètre désactivera également le paramètre de don récurrent.',
  enable_recurring_notice: `L'activation de ce paramètre activera également le paramètre de don récurrent.`,
  continue: 'Continuer',
  disable_subscription_notice: `La désactivation de ce paramètre désactivera également le paramètre d'abonnement.`,
  enable_subscription_notice: `L'activation de ce paramètre activera également le paramètre d'abonnement.`,
  select_stipe_to_enable_subscription: `Pour activer l'abonnement, vous devez sélectionner Stripe comme passerelle`,
  subscription_settings: `Paramètres d'abonnement`,
  allow_donation_to_enable_subscription: `Pour activer l'abonnement, vous devez autoriser le don`,
  allow_recurring_is_enabled:
    'Si la récurrence est autorisée, un abonnement sera créé pour le formulaire de don.',
  enable_subscription: `Activer l'abonnement`,
  Scard: 'Carte à rayures',
  Stripe_Session: 'Séance de rayures',
  e_wallet_setting: 'Paramètre de portefeuille électronique',
  enable_apple_gpay_link: 'Activer Apple Pay, Google Pay et LinkPay',
  enable_deal: `Activer l'accord`,
  allow_custom_product: 'Autoriser le produit personnalisé',
  custom_product_info_to_sell:
    'Si le produit personnalisé est autorisé, les produits formpay ne peuvent pas être ajoutés.',
  custom_product_settings: 'Paramètres de produit personnalisés',
  product_display_setting: `Paramètres d'affichage du produit`,
  if_custom_product_is_enable:
    'Si le produit personnalisé est autorisé, les produits formpay ne peuvent pas être ajoutés.',
  select_single: 'Sélectionnez un seul produit',
  recurring_can_be_allowed: `La répétition ne peut être autorisée qu'avec bande, veuillez sélectionner bande.`,
  sub_start: `Date de début de l'abonnement`,
  sub_duration: `Durée de l'abonnement`,
  sub_next: 'Prochaine date de paiement',
  details_raw: `Détails bruts`,
  allow_only_recurring: `Autoriser uniquement les paiements récurrents`,
};

export default fr;
